export const isDeepEmpty = (obj) =>
  Object.keys(obj).every((k) => !Object.keys(obj[k]).length);
